import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.error.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.find.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.join.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.push.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.slice.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.date.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.json.stringify.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.parse-int.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.regexp.to-string.js';
import { __awaiter, __generator, __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { useState, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import '../../TiForm/index.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.filter.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.iterator.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.set.constructor.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.string.iterator.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.iterator.js';
import { Tabs } from 'antd-mobile';
import { isFunction, isObject } from 'lodash';
import { RightOutline, CheckOutline } from 'antd-mobile-icons';
import '../../TiSelector/style/index.less.js';
import '../../TiList/index.js';
import TiSpin from '../../TiSpin/index.js';
import '../../TiPage/style/index.less.js';
import { TiException } from '../../TiException/index.js';
import '../../TiCard/styles/index.less.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.error.cause.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.concat.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.every.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.define-property.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.entries.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.for-each.js';
import '../../TiDescriptions/index.less.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.find-index.js';
import '../../TiDateRangePicker/style/index.less.js';
import 'dayjs';
import useLanguage from '../../hooks/useLangugle/index.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.function.name.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.map.constructor.js';
import '../../TiStepsForm/StepsForm/index.less.js';
import 'rc-util';
import { TiModal } from '../../TiModal/index.js';
import '../../TiTrapezoid/styles/index.less.js';
import '../../TiTrapezoid/LeftSVG/index.less.js';
import '../../TiTrapezoid/RightSVG/index.less.js';
import '../../TiRadio/index.js';
import '../../TiCheckBox/index.js';
import '../../TiAffix/Affix/index.js';
import { batchFindTreePath, batchModifyNode } from '../../utils/treeUtils.js';
import '../styles/index.less.js';
import '../../TiNotice/styles/index.less.js';
import '../../TiTag/styles/index.less.js';
import '@react-spring/web';
import '../../TiToggle/styles/index.less.js';
import '../../TiSearchBar/styles/index.less.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.is-array.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.regexp.exec.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.string.search.js';
import '../../TiSelectPage/styles/index.less.js';
import '../../TiPopupSelect/LazySelectPanel/index.less.js';
import '../../TiPopupSelect/SelectPanel/index.less.js';
import '../../TiPopupSelect/PopupSelect/index.less.js';
import '../../TiIcon/assets/iconFont.css.js';

function Cascader(props) {
  var _a;
  var _this = this;
  var commonLocale = useLanguage('Common');
  var title = props.title,
    value = props.value,
    onChange = props.onChange,
    request = props.request,
    _options = props.options,
    params = props.params,
    disabled = props.disabled,
    _b = props.placeholder,
    placeholder = _b === void 0 ? commonLocale.pleaseSelect : _b,
    renderTrigger = props.renderTrigger,
    lazyLoad = props.lazyLoad;
  var _c = useState(false),
    loading = _c[0],
    setLoading = _c[1];
  var _d = TiModal.useControl(),
    visible = _d.visible,
    onClose = _d.onClose,
    onOpen = _d.onOpen;
  var _e = useState(0),
    tabActiveIndex = _e[0],
    setTabActiveIndex = _e[1];
  var _f = useState(undefined),
    loadingKey = _f[0],
    setLoadingKey = _f[1];
  var _g = useState(_options || []),
    options = _g[0],
    setOptions = _g[1];
  var _h = useState([]),
    selected = _h[0],
    setSelected = _h[1];
  var current = value === null || value === void 0 ? void 0 : value.value;
  var currentOptions = batchFindTreePath(options, current);
  var stringifyParams = JSON.stringify(params);
  useEffect(function () {
    if (visible) {
      updateSelectedOptions(options, current);
    }
  }, [visible, current, options]);
  var updateSelectedOptions = function updateSelectedOptions(tree, target) {
    var changed = batchFindTreePath(tree, target);
    setSelected(changed);
  };
  var levels = useMemo(function () {
    var ret = [];
    var currentOptions = options;
    var reachedEnd = false;
    var _loop_1 = function _loop_1(v) {
      var target = currentOptions.find(function (option) {
        return option.value === v.value;
      });
      ret.push({
        selected: target,
        options: currentOptions
      });
      if (!target || !target.children) {
        reachedEnd = true;
        return "break";
      }
      currentOptions = target.children;
    };
    for (var _i = 0, selected_1 = selected; _i < selected_1.length; _i++) {
      var v = selected_1[_i];
      var state_1 = _loop_1(v);
      if (state_1 === "break") break;
    }
    if (!reachedEnd) {
      ret.push({
        selected: undefined,
        options: currentOptions
      });
    }
    return ret;
  }, [selected, options]);
  useEffect(function () {
    setTabActiveIndex(levels.length - 1);
  }, [selected]);
  useEffect(function () {
    var max = levels.length - 1;
    if (tabActiveIndex > max) {
      setTabActiveIndex(max);
    }
  }, [tabActiveIndex, levels]);
  useEffect(function () {
    handleRequest();
  }, [stringifyParams]);
  var handleRequest = function handleRequest() {
    return __awaiter(_this, void 0, void 0, function () {
      var _params, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!isFunction(request)) {
              return [2 /*return*/];
            }
            _params = isObject(params) ? params : {};
            setLoading(true);
            return [4 /*yield*/, request(__assign({}, _params))];
          case 1:
            res = _a.sent();
            setLoading(false);
            setOptions(res);
            return [2 /*return*/];
        }
      });
    });
  };
  var onItemSelect = function onItemSelect(selectOption, depth, supportLazyLoading) {
    return __awaiter(_this, void 0, void 0, function () {
      var incrementOptions, latestOptions, next;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (supportLazyLoading) {
              return [2 /*return*/];
            }
            if (!(selectOption.lazy && isFunction(lazyLoad))) return [3 /*break*/, 2];
            setLoadingKey(selectOption.value);
            return [4 /*yield*/, lazyLoad(selectOption)];
          case 1:
            incrementOptions = _a.sent();
            latestOptions = batchModifyNode({
              value: selectOption.value,
              label: selectOption.label,
              lazy: false,
              children: incrementOptions
            }, selectOption.value, options);
            setOptions(latestOptions);
            setLoadingKey(undefined);
            _a.label = 2;
          case 2:
            next = selected.slice(0, depth);
            if (selectOption !== undefined) {
              next[depth] = selectOption;
            }
            setSelected(next);
            return [2 /*return*/];
        }
      });
    });
  };
  var onConfirm = function onConfirm() {
    if (isFunction(onChange)) {
      var changed = {
        value: selected[selected.length - 1].value,
        label: selected.map(function (x) {
          return x.label;
        }).join('-')
      };
      onChange(changed, selected);
    }
  };
  var handleOpen = function handleOpen() {
    if (disabled) {
      return;
    }
    onOpen();
  };
  var triggerCls = classNames('ti-cascader-triggeer', (_a = {}, _a['ti-cascader-triggeer-disabled'] = disabled, _a));
  return /*#__PURE__*/React.createElement(React.Fragment, null, isFunction(renderTrigger) ? renderTrigger(currentOptions, {
    visible: visible,
    onClose: onClose,
    onOpen: onOpen
  }) : /*#__PURE__*/React.createElement("div", {
    className: triggerCls,
    onClick: handleOpen
  }, currentOptions.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "ti-cascader-placeholder"
  }, placeholder) : /*#__PURE__*/React.createElement("div", {
    className: "ti-cascader-display"
  }, currentOptions.map(function (x) {
    return x.label;
  }).join('-')), /*#__PURE__*/React.createElement("div", {
    className: "ti-cascader-icon"
  }, /*#__PURE__*/React.createElement(RightOutline, {
    color: "#999999",
    fontSize: 14
  }))), /*#__PURE__*/React.createElement(TiModal.Right, {
    onOpen: handleOpen,
    onClose: onClose,
    visible: visible,
    title: title,
    bodyStyle: {
      background: '#fff'
    },
    onConfirm: onConfirm,
    className: "ti-cascader",
    actions: loading ? false : undefined
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: "ti-cascader-loading"
  }, /*#__PURE__*/React.createElement(TiSpin, {
    presetStyle: "spin-logo"
  })) : /*#__PURE__*/React.createElement(Tabs, {
    activeKey: tabActiveIndex.toString(),
    onChange: function onChange(key) {
      var activeIndex = parseInt(key);
      setTabActiveIndex(activeIndex);
    },
    stretch: false
  }, levels.map(function (x, i) {
    var _a;
    var placeholder = ((_a = x.selected) === null || _a === void 0 ? void 0 : _a.label) || commonLocale.pleaseSelect;
    return /*#__PURE__*/React.createElement(Tabs.Tab, {
      key: i,
      title: placeholder
    }, x.options.length === 0 ? /*#__PURE__*/React.createElement(TiException.Empty, null) : x.options.map(function (item) {
      var _a;
      var _b;
      var active = ((_b = x.selected) === null || _b === void 0 ? void 0 : _b.value) === item.value;
      var mergeCls = classNames('ti-cascader-node', (_a = {}, _a['ti-cascader-node-active'] = active, _a));
      var supportLazyLoading = item.value === loadingKey;
      return /*#__PURE__*/React.createElement("div", {
        key: item.value,
        className: mergeCls,
        onClick: function onClick() {
          return onItemSelect(item, i, supportLazyLoading);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "ti-cascader-node-title"
      }, item.label), supportLazyLoading ? /*#__PURE__*/React.createElement(TiSpin, {
        presetStyle: "spin",
        size: "small"
      }) : null, active && !loading ? /*#__PURE__*/React.createElement("div", {
        className: "ti-cascader-node-icon"
      }, /*#__PURE__*/React.createElement(CheckOutline, {
        color: "var(--adm-color-primary)"
      })) : null);
    }));
  }))));
}

export { Cascader as default };
